module.exports = __webpack_public_path__ + "assets/img/welcome_2.51c6ade2.png";